import React, {Component} from 'react';
import API from "../../services/API";
import Actionbar from "../Common/Actionbar";
import Navbar from "../Common/Navbar";
import Loading from "../Common/Loading";
import {RiMapPinLine,  VscCallOutgoing} from "react-icons/all";

class Agents extends Component {
    state = {
        agents: [],
        isLoaded: false,
    }

    render() {
        return (
            <React.Fragment>
                <Actionbar noBack={0} title='لیست نمایندگان'/>
                {
                    !this.state.isLoaded && <Loading/>
                }
                <section className="container mt-2 py-5">
                    {
                        this.state.agents.map ((agent , index) => {
                            return (
                                <div className="row transaction-item" key={agent.id} >

                                    <div className="col-7 mb-3 text-secondary text-small-1">
                                        {index + 1}
                                        -
                                        &nbsp;
                                        <span className='title text-primary-color text-big-1'>{agent.name} </span>
                                        (
                                        کد:
                                        {agent.cod}
                                        )
                                    </div>
                                    <div className="col-5 mb-3 text-small-1 text-info text-left pt-2">
                                        <a href={`tel:${agent.mobil}`} className='text-info text-decoration-none' target="_blank" rel="noreferrer">
                                            {agent.mobil}
                                            <VscCallOutgoing className='text-success mx-2' />
                                        </a>
                                    </div>
                                    <div className="col-1">
                                        <RiMapPinLine  className='text-big-2 text-secondary ' />
                                    </div>
                                    <div className="col-11 text-small-2 fw-bold mt-2 text-white" >
                                        {agent.city} - {agent.address}
                                    </div>
                                </div>
                            )
                        })
                    }
                </section>
                <Navbar/>
            </React.Fragment>
        );
    }

    componentDidMount = () => {
        API.getAgents()
            .then((response) => {

                this.setState({isLoaded: true, 'agents': response.agent})
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
    }
}

export default Agents;